import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useScaleApplication } from "@/domains/application/use-scale-application"

/**
 * Hook to sync the router id parameter to the LockPageStore's selectedLockId.
 * This ensures that when navigating to a lock sub-page, the selected lock is set in the store.
 */
export function useSyncLockIdFromRouter(): void {
  const { id } = useParams<{ id: string }>()
  const scaleApp = useScaleApplication()

  useEffect(() => {
    if (id) {
      const parsedId = Number(id)
      if (!isNaN(parsedId)) {
        // Only update if it's different from current selection
        const currentId = scaleApp.Pages.Lock.selectedLockId
        if (currentId !== parsedId) {
          scaleApp.Pages.Lock.setSelectedLockId(parsedId)
        }
      }
    }
  }, [id, scaleApp.Pages.Lock])
}

